<template>
  <div :id="this.$vnode.key === 1 ? 'crop-image-page' : ''" class="crop-image-page" v-if="report">
    <div class="d-flex justify-end">
      <div class="mx-8 my-4">
        <div class="d-flex justify-end">
          <span class="black--text font-weight-bold" style='font-family:"MS Pゴシック", sans-serif !important; font-size: 11px'>Confidential</span>
        </div>
        <v-img :src="require('@/assets/images/report_header.png')" width="120px" eager></v-img>
      </div>
    </div>
    <div class="ma-10 mt-0" style="height: 930px; position: relative;">
      <div class="d-flex justify-start mb-3">
        <span class="text-h5 font-weight-bold my-auto mr-4" style="height: 36px;">{{naviVisibleList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）') - 1}}. ドローン検査詳細（抜粋）</span>
      </div>
      <div v-for="(image, index) in images" :key="index">
        <v-row v-if="image.src">
          <v-col>
            <img :src="image.src.concat('?timestamp=' + Date.now())" style="height: 280px; width: 350px;" />
          </v-col>
          <v-col>
            <div>
              <p class="text-subtitle-1 font-weight-bold pt-1 text-justify" style="border-bottom: 2px solid #000">
                {{errorType[image.errorType]}}
                <span v-if="image.errorReason">
                  （{{errorReason[image.errorReason]}}）
                </span>
              </p>
              <p class="text-subtitle-1 text-justify" v-html="displayNote(image.errorNote)">
              </p>
            </div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <div style="height: 280px; width: 100%;"></div>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="mr-8">
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐</span>
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">{{naviVisibleList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）') + this.$vnode.key + 2}}/{{naviVisibleList.length + pdfPageNum + cropImagePageNum + 1}}</span>
      </div>
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 11px">Copyright East Engineering Co., Ltd. all rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "CropImagePage",
  props: ['report', 'selectedImages', 'naviVisibleList', 'cropImagePageNum', 'pdfPageNum'],
  data() {
    return {
      errorType: {
        'cell': 'ホットスポット',
        'multicell': 'マルチホットスポット',
        'cluster': 'クラスタバイパス',
        'module': 'モジュール異常',
        'string': 'ストリング異常',
        'junction': 'ジャンクションボックス過熱',
        'pid': 'ＰＩＤ現象の疑い',
        'shadow': '影',
      },
      errorTypes: [
        { text: "ホットスポット", value: "cell"},
        { text: "マルチホットスポット", value: "multicell"},
        { text: "クラスタバイパス", value: "cluster" },
        { text: "モジュール異常", value: "module"},
        { text: "ストリング異常", value: "string"},
        { text: "ジャンクションボックス過熱", value: "junction" },
        { text: "ＰＩＤ現象の疑い", value: "pid" },
        {text: "影", value: "shadow"},
      ],
      errorReason: {
        "crack": "割れ",
        "sediment": "堆積物",
        "vegetation": "植生"
      },
      errorReasons: [
        {text: "割れ", value: "crack"},
        {text: "堆積物", value: "sediment"},
        {text: "植生", value: "vegetation"},
      ],
      test: null,
      images: [],
      folderUuid: this.$route.params.folderUuid,
      errorNotes: {
        type: {
          'cell': 'モジュールの一部に発熱が見受けられます。',
          'multicell': '複数のセルに発熱が見受けられます。',
          'cluster': 'クラスタ全体が発熱している状態となっております。発熱箇所が発電に寄与していないもしくは、性能が極端に低下していると推定されます。',
          'string': 'ストリング全体が発熱している状態となっております。発熱箇所が発電に寄与していないもしくは、性能が極端に低下していると推定されます。',
          'shadow': '周囲の構造物・樹木によりモジュールに影がかかっております。\nこれにより、発電量が低下していると推定されます。',
          'junction': 'ジャンクションボックスが過熱している状態となっております。',
          'module': 'モジュール全体が発熱している状態となっております。\n本パネルは発電に寄与していないと推定されますので、取り換えを推奨いたします。',
          'pid': 'PID現象が発生していると推定されます。',
          null: ''
        },
        reason: {
          null: '',
          'unknown': '',
          'vegetation': 'こちらはモジュールセルを覆う草木の影により発生していると推定されます。',
          'sediment': 'こちらは堆積物により発生していると推定されます。',
          'crack': 'モジュールガラス面が割れており、絶縁性能低下に伴うPCS停止により発電量低下等を引き起こす可能性がありますので、取り換えを推奨いたします。'
        }
      }
    }
  },
  methods: {
    displayNote(note){
      if (note){
        return note.replace('\n', '<br>');
      }
      else return null;
    },
  },

  watch: {
    selectedImages(val) {
      if (val.length > 0){
        const key = this.$vnode.key;
        if (key * 3 > val.length){
          this.images = val.slice((key - 1) *3, val.length);
        }
        else {
          this.images = val.slice((key - 1) *3, key*3);
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
